<h5 mat-dialog-title>{{data.title}}</h5>
<div mat-dialog-content>
    <mat-card>
        <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
    </mat-card>
</div>